import { memo } from 'react';
import { useSettings } from '@wu/widget-core';
import { List, Tabs } from './menu-layouts';

export const Menu = memo(() => {
  const { menusLayout } = useSettings();

  return (
    <>
      {menusLayout === 'list' && <List />}
      {menusLayout === 'tabs' && <Tabs />}
    </>
  );
});
